// extracted by mini-css-extract-plugin
export var active = "slider-dots-module--active--fp3-v";
export var dark = "slider-dots-module--dark--my8yz";
export var dotButton = "slider-dots-module--dot-button--6mqCB";
export var dotItem = "slider-dots-module--dot-item--RNjZy";
export var dotList = "slider-dots-module--dot-list--tbaPu";